module.exports = __webpack_public_path__ + "img/20200509145434TIM截图20200509143515.34090384.png";